<template>
  <div>
    <div class="grid-x grid-padding-x">
      <div class="cell small-12">
        <div class="bordered pad">
          <h1>Add a file for {{ user.first_name }} {{ user.last_name }}</h1>
        </div>
      </div>
    </div>
    <div class="grid-x grid-padding-x pad-top">
      <div class="cell small-12">
        <div class="bordered pad">
          <form class="file-form">
            <div class="grid-x grid-padding-x">
              <div class="cell small-12 medium-6">
                <label>Title<sup class="text-red">*</sup></label>
                <select v-model="file.title">
                  <option
                    v-for="(heading, index) in fileHeadings"
                    v-bind:value="heading.heading"
                    v-bind:key="index">
                    {{ heading.heading }}
                  </option>
                </select>
                <label>Sub-title</label>
                <input
                  type="text"
                  v-model="file.subTitle">
                <label>Description of Evidence</label>
                <vue-editor
                  id="notesEditor"
                  v-bind:editorToolbar="customToolbar"
                  v-model="file.notes"
                  placeholder="Must include a note to explain what your evidence is."
                  rows="12">
                </vue-editor>
              </div>
              <div class="cell small-12 medium-6">
                <label>Evidence</label>
                <label>Click the button below to select a file to upload</label>
                <div class="file-three"></div>
                <div><p>{{ evFilename }}</p></div>
                <div class="pad-top">
                  <button class="button">Save Evidence</button>
                </div>
                <div class="UppyProgressBar"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      v-if="message.length > 0"
      class="message-wrap">
      <span class="close-message" v-on:click="reload()">X</span>
      <p class="message-text">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import axios from '../axios';
import '@uppy/core/dist/style.css';
import '@uppy/file-input/dist/style.css';
import '@uppy/progress-bar/dist/style.css';

const Uppy = require('@uppy/core');
const UppyForm = require('@uppy/form');
const Transloadit = require('@uppy/transloadit');
const ProgressBar = require('@uppy/progress-bar');
const FileInput = require('@uppy/file-input');

export default {
  name: 'AddFile',
  data() {
    return {
      fileHeadings: [],
      user: {},
      file: {
        title: '',
        myTitle: '',
        subTitle: '',
        notes: '',
        fileOneName: '',
      },
      evFilename: '',
      message: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: '1' }, { header: '2' }],
        ['link'],
      ],
    };
  },
  computed: {
    authData() {
      return this.$store.getters.authData;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    courseChosen() {
      return this.$store.getters.courseChosen;
    },
  },
  methods: {
    getFileHeadings() {
      const learner = this.$route.params.id;
      axios.get(`/files/getHeadings.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}&learner=${learner}&course=${this.courseChosen}`)
        .then((response) => {
          this.fileHeadings = response.data.fileHeadings;
        });
    },
    getUser() {
      const userId = this.$route.params.id;
      axios.get(`/users/getUser/${userId}.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`, this.user)
        .then((response) => {
          this.user = response.data.user;
          this.setCurrentLearner();
        });
    },
    saveFile(result) {
      this.file.userId = this.$route.params.id;
      this.file.files = result;
      this.file.course = this.courseChosen;
      axios.post(`/files/add.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`, this.file)
        .then((response) => {
          if (response.data.response === true) {
            this.message = 'The file has been added successfully';
          } else {
            this.message = 'The file could not be added - please check the details';
          }
        });
    },
    reload() {
      // eslint-disable-next-line
      location.reload();
    },
    clearMessage() {
      this.message = '';
    },
    setCurrentLearner() {
      this.$store.dispatch('selectCurrentLearner', this.user.id);
    },
  },
  mounted() {
    this.getFileHeadings();
    this.getUser();
    Uppy({
      debug: true,
      autoProceed: false,
      restrictions: {
        maxFileSize: (1000000 * 1000),
        maxNumberOfFiles: 3,
        minNumberOfFiles: 0,
      },
    })
      .use(UppyForm, {
        target: '.file-form',
        multipleResults: true,
        triggerUploadOnSubmit: true,
        submitOnSuccess: false,
      })
      .use(FileInput, {
        id: 'FileInputThree',
        target: '.file-three',
        pretty: true,
        inputName: 'evidence',
      })
      .on('file-added', (res) => {
        this.evFilename = res.name;
      })
      .use(ProgressBar, {
        target: '.UppyProgressBar',
        hideAfterFinish: false,
      })
      .use(Transloadit, {
        service: 'https://api2.transloadit.com',
        params: {
          auth: { key: 'db6a1d40944f11e5a0a165fb32f6e49b' },
          template_id: 'ad27d2c2cad8454fba2791c04c58c00e',
        },
        waitForEncoding: true,
        waitForMetadata: false,
        importFromUploadURLs: false,
        alwaysRunAssembly: false,
        signature: null,
      })
      .on('complete', (result) => {
        this.saveFile(result);
      });
  },
};
</script>
